import { Pipe, PipeTransform } from '@angular/core';
/**
 * Truncate string pipe
 */
@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  /**
   * Truncate string if it's biger than limit.
   *
   * @param value string vallue.
   * @param limit limited number of caracters.
   * @returns string
   */
  public transform(value: string, limit: number): string {
    return value?.length <= limit ? value : `${value?.slice(0, limit)}...`;
  }
}
